/**
 * @fileoverview Bridge the third-party date picker to shared form conventions. The parent owns the selected date and persistence; this adapter emits the shared value envelope. `AppDateInput.js` is the native-input alternative and has a different callback boundary.
 */

import React from 'react'
import DatePicker from 'react-date-picker'

/**
 * onChange receives {value: Date|null}, matching the shared picker convention. It does not receive a native DOM event or the direct Date value used by AppDateInput. The parent owns validation and saving.
 */
function AppCalendar({ value, onChange, placeholder, disabled, className }) {
    const handleChange =

    (date) => {
        if (onChange) {
            onChange({ value: date })
        }
    }

    return (
        <DatePicker
            value={value}
            onChange={handleChange}
            disabled={disabled}
            className={className || ''}
            calendarIcon={null}
            clearIcon={null}
            format="MM/dd/yyyy"
        />
    )
}

export default AppCalendar
